<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
        <div class="-two-columns">
            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>

            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Types d'indisponibilité de ressource</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id && !form.deleted_at">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h1 class="o-form__title">Types d'indisponibilité de ressource</h1> -->
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            >
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="name"
                                    label="Nom du type d'indisponibilité de ressource"
                                    v-model="form.name"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <q-input v-model="form.color" class="my-input" @focus="$refs.pickerProxy.show()" label="Couleur" placeholder="#000000"
                                    :filled="false" dense :outlined="true">
                                    <template v-slot:before>
                                        <q-icon name="bookmark" :style="'color: ' + form.color" @click="$refs.pickerProxy.show()" />
                                    </template>
                                    <template v-slot:append>
                                        <q-icon name="colorize" class="cursor-pointer">
                                            <q-popup-proxy ref="pickerProxy" transition-show="scale" transition-hide="scale">
                                                <q-color v-model="form.color" />
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>
                            </div>
                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->
                        </fieldset>
                    </form>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    import { RESOURCEUNAVAILABILITYTYPES } from '@/graphql/resourceUnavailability/queries'
    import { UPSERTRESOURCEUNAVAILABILITYTYPE, DELETERESOURCEUNAVAILABILITYTYPE, RESTORERESOURCEUNAVAILABILITYTYPE } from '@/graphql/resourceUnavailability/mutations'
    import { removeNULL } from '@/js/utilities'

    export default {
        name: "ResourceUnavailabilityTypes",
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchable: 'Rechercher / filtrer'
                },
                searchContactText: null,
                form: {},
                applyToOptions: [],
                newItem: {
                    id: 0,
                    name: null,
                    // type: "OTHER",
                    description: null,
                    tracked: false,
                    color: '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
                },
                typeOptions: [],
                showDeleted: false,
            }
        },
        mounted: async function(){
            this.setNewItem()
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form=Object.assign({}, item);
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form=Object.assign({}, this.newItem);

                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETERESOURCEUNAVAILABILITYTYPE,
                    variables: { ...form },
                    update: () => {
                        this.$apollo.queries.resourceUnavailabilityTypes.refetch()
                        this.setSelected(null);
                        // const data = store.readQuery({ query: ABSENCETYPES })
                        // data.absenceTypes = data.absenceTypes.filter(item => item.id !== deleteAbsenceType.id);
                        // store.writeQuery({
                        //     query: ABSENCETYPES,
                        //     data,
                        // })
                        // return data;
                    }
                }).finally(() => {
                    this.setNewItem();
                })
            },
            saveItem(form) {
                form=removeNULL(form);
                this.$apollo.mutate({
                    mutation: UPSERTRESOURCEUNAVAILABILITYTYPE,
                    variables: { ...form },
                    update: (store, { data: { upsertResourceUnavailabilityType } }) => {
                        if (!form.id) {
                            let myVariables = { trashed: this.trashed }
                            const data = store.readQuery({ query: RESOURCEUNAVAILABILITYTYPES, variables: myVariables })
                            data.resourceUnavailabilityTypes.push(upsertResourceUnavailabilityType);
                            store.writeQuery({
                                query: RESOURCEUNAVAILABILITYTYPES,
                                data,
                            })
                        }
                        this.setSelected(upsertResourceUnavailabilityType)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Ressource : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORERESOURCEUNAVAILABILITYTYPE,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { restoreResourceUnavailabilityType } }) => {
                        if (!form.id) {
                            const data = store.readQuery({ query: RESOURCEUNAVAILABILITYTYPES })
                            data.resourceUnavailabilityTypes.push(restoreResourceUnavailabilityType);
                            store.writeQuery({
                                query: RESOURCEUNAVAILABILITYTYPES,
                                data,
                            })
                        }
                        this.setSelected(restoreResourceUnavailabilityType)
                    }
                }).then(() => {
                    this.$q.notify({ type: 'positive', message: "Ressource : " + form.name, caption: "Informations sauvegardées" })
                }).catch(e => {
                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                })
            }
        },
        apollo: {
            resourceUnavailabilityTypes: {
                query: RESOURCEUNAVAILABILITYTYPES,
                fetchPolicy: 'network-only',
                variables() {
                    return {
                        trashed: this.trashed
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data) {
                    this.listbox.listItems = Object.assign([], data.resourceUnavailabilityTypes)
                }
            },
        }
    }
</script>